export default "__VITE_ASSET__CJhEh4kc__"